<template>
  <div>
    <p>
      Настоящий документ (далее – Условия) определяет порядок обработки персональных данных лиц, желающих принять участие в мероприятии «Итоги года с Владимиром Путиным» (далее – Мероприятие) способами, установленными настоящими Условиями, включая пользователей интернет-сайта (далее - Интернет-ресурс):
    </p>
    <p><em>- moskva-putinu.ru (москва-путину.рф) и его поддомена video.moskva-putinu.ru.</em></p>
    <p>Операторами, осуществляющим обработку персональных данных (далее – Операторы), являются:</p>
    <table border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td width="50%" valign="top">
          При обращении по видеосвязи и через Интернет-ресурсы: москва-путину.рф, moskva-putinu.ru и его поддомену video.moskva-putinu.ru.
        </td>
        <td width="50%" valign="top">
          Федеральное государственное унитарное предприятие «Всероссийская государственная телевизионная и радиовещательная компания» (ФГУП «ВГТРК»);
          ОГРН 1027700310076;<br />
          Адрес местонахождения: 125040, г. Москва, вн.тер.г. муниципальный округ Беговой, ул. 5-я Ямского поля, д. 19-21, стр. 1
        </td>
      </tr>
      <tr>
        <td valign="top">
          При обращении по телефону 8 (800) 200-40-40 и (или) посредством направления SMS/MMS по номеру 0-40-40, в том числе при помощи приложения «Москва-Путину».
        </td>
        <td valign="top">
          Публичное акционерное общество «Ростелеком» (ПАО «Ростелеком»);<br />
          ОГРН 1027700198767;<br />
          Адрес местонахождения: Российская Федерация, 191167, г. Санкт-Петербург, вн.тер.г. муниципальный округ Смольнинское, наб. Синопская, д. 14, лит. А;<br />
          Почтовый адрес: 115172, Российская Федерация, Москва, ул. Гончарная, д. 30, стр. 1

        </td>
      </tr>
    </table>
    <ol>
      <li>
        Лицом, желающим принять участие в мероприятии (далее также – Субъект персональных данных), является лицо, вносящее регистрационные данные в соответствующую форму, размещенную на Интернет-ресурсе, и (или) лицо, обратившееся по видеосвязи и (или) по телефону 8 (800) 200-40-40 и (или) посредством направления SMS/MMS по номеру 0-40-40.
      </li>
      <li>
        Субъект персональных данных, совершая действия в соответствии с пунктом 1 Условий, подтверждает, что ознакомлен с Условиями и выражает согласие на его информирование, в том числе направление сообщений, уведомлений, рассылок, материалов, совершения звонков, вызовов в соответствии со ст. 44.1-1 Федерального закона от 07.07.2003 № 126-ФЗ «О связи», проведения опросов и т.д., организациями, указанными в пункте 7 Условий с использованием любых средств связи по всем контактным данным, предоставленным Субъектом персональных данных для достижения целей, предусмотренных пунктом 5 Условий.
      </li>
      <li>
        Операторами обрабатываются данные, предоставляемые Субъектом персональных данных, в том числе: фамилия, имя, отчество; пол; дата рождения, сведения о возрасте; место рождения; адрес регистрации, адрес проживания; гражданство; семейное положение; социальное положение; данные о детях; образование; сведения о трудовой деятельности; фотографии; номер контактного телефона; адрес электронной почты; паспортные данные и другие данные – в случае их предоставления.
      </li>
      <li>
        Пользователь отвечает за достоверность предоставленных данных и самостоятельно несет риски наступления любых неблагоприятных последствий в случае предоставления чужих и (или) недостоверных данных.
      </li>
      <li>
        Персональные данные обрабатываются в целях обеспечения участия Субъекта персональных данных в Мероприятии, в том числе предоставления доступа к Интернет-ресурсу, подготовки и направления пользователю ответов на его запросы, а также для сбора статистических данных, проведения исследований и анализа таких данных.
      </li>
      <li>
        Действия, совершаемые с персональными данными: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, передача (предоставление, доступ), блокирование, удаление. Персональные данные обрабатываются с использованием средств автоматизации.
      </li>
      <li>
        Для достижения целей, указанных в пункте 4 Условий, Персональные данные могут указанным передаваться Операторами друг другу, а также иным третьим лицам:
        <ul>
          <li>органы государственной власти Российской Федерации, органы государственной власти субъектов Российской Федерации, органы местного самоуправления;</li>
          <li>Общероссийское общественное движение «НАРОДНЫЙ ФРОНТ «ЗА РОССИЮ» (ОГРН 11377990166954);</li>
          <li>Акционерное общество «Центр хранения данных» (ОГРН 1247700651461);</li>
          <li>Акционерное общество «Московский центр новых технологий телекоммуникаций» (ОГРН 1027739152418);</li>
          <li>Акционерное общество «Центр биометрических технологий» (ОГРН 1227700243748);</li>
          <li>Публичное акционерное общество «Сбербанк России» (ОГРН 1027700132195);</li>
          <li>Общество с ограниченной ответственностью «Центр речевых технологий» (ОГРН 1027810243295).</li>
        </ul>
      </li>
      <li>
        Операторы соблюдают конфиденциальность персональных данных и обеспечивают безопасность персональных данных при их обработке, а также соблюдают применимые
        требования законодательства РФ.
      </li>
      <li>
        Операторы соблюдают конфиденциальность персональных данных и обеспечивает безопасность персональных данных при их обработке, а также соблюдают применимые требования законодательства РФ.
      </li>
      <li>
        Операторы не осуществляют трансграничную передачу персональных данных.
      </li>
      <li>
        Персональные данные обрабатываются до достижения цели обработки и в течение 3 (трех) лет с указанного момента, если иной срок обработки не следует из требований законодательства РФ.
      </li>
      <li>
        Пользователь в любой момент вправе направить Операторам заявление о прекращении обработки (отозвать согласие на обработку) персональных данных путем направления заявления в письменной форме по адресу (в зависимости от формы обращения для участия в Мероприятии):
        <ul>
          <li>для ФГУП «ВГТРК»: 115162, г. Москва, ул. Шаболовка, д. 37.</li>
          <li>для ПАО «Ростелеком»: 115172, Российская Федерация, Москва, ул. Гончарная, д. 30, стр. 1.</li>
        </ul>
        При этом пользователь признает и соглашается с тем, что с момента направления заявления о прекращении обработки (отзыва согласия на обработку)
        участие в Мероприятии станет невозможным или будет ограничено.
      </li>
      <li>
        При этом пользователь признает и соглашается с тем, что с момента направления заявления о прекращении обработки (отзыва согласия на обработку) участие в Мероприятии станет невозможным или будет ограничено.
      </li>
    </ol>
  </div>
</template>

<script>
export default {};
</script>
